import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetTransactionHistory = () => {
    const send = useGenericSend();

    return useCallback(async (
        params: Types.IGetTransactionHistoryRequestData
    ): Promise<Types.IGetTransactionHistoryResponseData> => {
        const { data } = await send<Types.IGetTransactionHistoryRequestData, Types.IGetTransactionHistoryResponseData>({
            ID: 33026,
            description: 'Get Transaction history',
            responses: [33027, 33028],
            ...params
        });

        return data;
    }, [send]);
};
